import { User } from 'oidc-client'
import { atom } from 'recoil'

const UserAuth = atom<{ user?: User; id_token?: string; profile?: any; renewing?: boolean }>({
  key: 'UserAuth',
  default: { renewing: false }
})

export default UserAuth
